import React from "react";
import { BrowserView, MobileView } from "react-device-detect";
import Modal from "react-modal";

const ServiceDialog = ({ showDialog, title, description, img, items, onClose }) => {
    const imageWidth = 250;
    const imageHeight = 300;

    const mobileImageWidth = 120;
    const mobileImageHeight = 150;

    return (
        <div>
            <BrowserView>
                <Modal
                    isOpen={showDialog}
                    onAfterOpen={() => {
                        console.log("AFTER MODAL OPEN");
                    }}
                    onRequestClose={() => onClose()}
                    style={{
                        content: {
                            top: "20%",
                            left: "25%",
                            right: "25%",
                            bottom: "auto",
                            minHeight: "400px",
                        },
                        overlay: {
                            backgroundColor: "var(--secondary-color-80)",
                        },
                    }}
                    contentLabel={title}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                >
                    <div className="fg-primary d-flex flex-col justify-content-start align-items-center position-relative">
                        <button onClick={() => onClose()} className="position-absolute top-0 right-0">
                            Close
                        </button>
                        <h2 className="font-semibold my-4 text-2xl text-center">{title}</h2>
                        <p className="text-md font-medium text-center w-70p">{description}</p>
                        <div className="d-flex flex-row">
                            <img
                                alt="card img"
                                className="flex-0 rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out mr-20 my-10"
                                width={imageWidth}
                                height={imageHeight}
                                src={img}
                            />
                            <ul className="flex-1 d-flex flex-col justify-content-start align-items-start mt-10">
                                {items
                                    .filter((item) => item != null && item != "")
                                    .map((item, i) => {
                                        return (
                                            <li key={i} className="text-md font-medium fg-secondary service-item mb-2">
                                                {item}
                                            </li>
                                        );
                                    })}
                            </ul>
                        </div>
                    </div>
                </Modal>
            </BrowserView>
            <MobileView>
                <Modal
                    isOpen={showDialog}
                    onAfterOpen={() => {
                        // console.log("AFTER MODAL OPEN");
                    }}
                    onRequestClose={() => onClose()}
                    style={{
                        content: {
                            top: "10%",
                            left: "5%",
                            right: "5%",
                            bottom: "auto",
                            minHeight: "400px",
                        },
                        overlay: {
                            backgroundColor: "var(--secondary-color-80)",
                        },
                    }}
                    contentLabel={title}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                >
                    <div className="fg-primary d-flex flex-col justify-content-start align-items-center position-relative">
                        <button onClick={() => onClose()} className="position-absolute top-0 right-0">
                            Close
                        </button>
                        <img
                            alt="card img"
                            className="flex-0 rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out mr-5"
                            width={mobileImageWidth}
                            height={mobileImageHeight}
                            src={img}
                        />
                        <h2 className="font-semibold my-2 text-xl text-center">{title}</h2>
                        <p className="flex-1 text-sm text-left w-80p">{description}</p>
                        <ul className="d-flex flex-col justify-content-start align-items-start mt-5 w-70p">
                            {items
                                .filter((item) => item != null && item != "")
                                .map((item, i) => {
                                    return (
                                        <li key={i} className="text-sm fg-secondary service-item mb-2">
                                            {item}
                                        </li>
                                    );
                                })}
                        </ul>
                    </div>
                </Modal>
            </MobileView>
        </div>
    );
};

export default ServiceDialog;
